import { v4 } from "uuid";
import { Condition } from "../condition/condition";
import { HighlightStyle } from "./highlight-style";
import { getModel, Model } from "../models/model";

let model:Model = null as any as Model;
requestAnimationFrame(()=>{
	model = getModel("SaleRow");
});


export class Highlight {
	uid:string = v4();
	Style:HighlightStyle = new HighlightStyle();
	Conditions:Condition[] = [];

	public constructor(data?:any){
		if (!data) return;
		this.Style = new HighlightStyle(data.Style);
		this.Conditions = (data.Conditions || []).map((c:any)=>new Condition(c));
	}

	public static makeGetFieldNameFunc():(val:string)=>string{
		return (val:string)=>{
			let field = model.getField(val);
			if (!field) return "ERROR";
			return field.getPropertyTranslation();
		};
	}

	public toString(){
		return Condition.conditionsToShortString(Highlight.makeGetFieldNameFunc(), this.Conditions);
	}

	public getJSON(){
		return {
			Style: this.Style.getJSON(),
			Conditions: this.Conditions.map(c=>c.getJSON())
		};
	}

}